import React, {useEffect, useRef, useState} from "react";
import {Tooltip} from "@mui/material";
import Box from "@mui/material/Box";

const OverflowTooltip = ({title, children}) => {
    const ref = useRef(null)
    const [overflowed, setOverflowed] = useState(false)

    useEffect(() => {
        const el = ref.current
        if (el == null) {
            return
        }
        const update = () => {
            setOverflowed(el.scrollWidth > el.clientWidth)
        }
        update()
        const observer = typeof ResizeObserver === "function" ? new ResizeObserver(update) : null
        observer?.observe(el)
        window.addEventListener("resize", update)
        return () => {
            observer?.disconnect()
            window.removeEventListener("resize", update)
        }
    }, [title, children])

    return (
        <Tooltip
            title={title ?? ""}
            arrow
            placement="top"
            disableHoverListener={!overflowed}
        >
            <Box
                ref={ref}
                component="span"
                sx={{
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    minWidth: 0,
                }}
            >
                {children}
            </Box>
        </Tooltip>
    )
}

export default OverflowTooltip
